import Store from '../../../services/store'
import pano from '../../pano/module'
import home from '../../home/module'
import facilities from '../../facilities/module'
import documentManagement from '../../documentManagement/module'
import maps from '../../maps/module'
import currentActivityReports from "@/modules/currentActivityReports/module";
import constructionStandards from '@/modules/constructionStandards/module'
import accounts from '@/modules/accounts/module'
import addresses from '@/modules/campusAddresses/module'
import dashboards from '@/modules/dashboards/module'
import definitions from "@/modules/definitions/module"
import reports from "@/modules/reports/module"
import {version} from '../../../../package.json'
//import modules from "vue/src/core/vdom/modules";

export default {
    namespaced: true,
    state: {
        version: '',
        routes: []
    },
    getters: {},
    mutations: {
        addRoutes(state, payload) {
            state.routes = state.routes.concat(payload.items)
        },
        setVersion(state, payload) {
            state.version = payload.value
        }
    },
    actions: {
        initialize({dispatch, commit}) {
            console.info('System initializing...')
            commit('setVersion', {
                value: version
            })
            console.info('System initialized.')

            dispatch('initializeModule', home)
            dispatch('initializeModule', dashboards)
            dispatch('initializeModule', facilities)
            dispatch('initializeModule', documentManagement)
            dispatch('initializeModule', maps)
            dispatch('initializeModule', pano)
            dispatch('initializeModule', constructionStandards)
            dispatch('initializeModule', currentActivityReports)
            dispatch('initializeModule', reports)
            dispatch('initializeModule', accounts)
            dispatch('initializeModule', addresses)
            dispatch('initializeModule', definitions)
        },

        initializeModule({dispatch}, module) {
            if (module.routes) {
                dispatch('addRoutes', module.routes)
            }
            if (module.store) {
                Store.registerModule(module.name, module.store)
                dispatch(module.name + '/initialize', null, {root: true})
            }
        },

        addRoutes({commit}, routes) {
            commit('addRoutes', {
                items: routes
            })
        }
    }
}
